// import { usePageTitle } from "../hooks/usePageTitle";
import { allProfilesCategories } from "../data/CategoriesData"
import Pagination from "../utilities/Pagination";
import { useState, useEffect } from 'react';
import { apiFetch } from '../hooks/apiFetch';
import ProfileSample from "../features/profile/ProfileSample";
import ProfileSideList from "../features/profile/components/ProfileSideList";
import { useTranslation } from 'react-i18next';
import { useMetadata } from "../hooks/useMetadata";

export default function Profile() {
    const [profileWorks, setProfileWorks] = useState("");
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [error, setError] = useState(null);
    const filteredProfileWorksData = selectedCategory === null ? profileWorks?.data?.result : profileWorks?.data?.result.filter(item => item.service.name === selectedCategory);
    const totalPages = profileWorks?.data?.paginationInfo.totalPagesCount;
    const totalItemCount = profileWorks?.data?.paginationInfo.totalCount;
    const { t, i18n } = useTranslation();
    useMetadata(i18n.language);

    // usePageTitle('Profile');

    useEffect(() => {
        async function fetchProfileWorks() {
            try {
                const works = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/works?${selectedCategory ? `service=${selectedCategory}&` : ""}page=${currentPage}&limit=12`);

                setProfileWorks(works);
            } catch (err) {
                setError(t("errorGetData"));
            }
        }

        fetchProfileWorks();
    }, [currentPage, selectedCategory, t]);


    const handleChange = (event) => {
        setSelectedCategory(event.target.value);
    };


    if (error) {
        return <div className="text-center my-4 text-danger">{error}</div>;
    }
    if (!profileWorks) {
        return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    }

    return (
        <div className="container mt-4">
            <h3 className="c-darkOrange col-12">{t("Our Work")}</h3>
            <div className="d-flex flex-wrap justify-content-between">
                <ProfileSideList
                    allProfilesCategories={allProfilesCategories}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    setCurrentPage={setCurrentPage}
                    itemCount={totalItemCount}
                    handleChange={handleChange}
                />
                <div className="d-flex flex-wrap justify-content-evenly col-12 col-md-9 pt-1 align-content-start">
                    {(filteredProfileWorksData).map((item) => (
                        <ProfileSample
                            key={item.id}
                            id={item.id}
                            description={item.description}
                            imgSrc={item.thumbnail}
                            imgAlt={`profileWorks_${item.id}`}
                            imgCat={allProfilesCategories.map(cat =>
                                cat.en === item.service?.name ? (i18n.language === "ar" ? cat.ar : cat.en) : "")
                            } />
                    ))}
                </div>
            </div>
            <div className="col-12">
                {totalPages > 1 &&
                    <Pagination
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={totalPages} />
                }
            </div>
        </div>
    );
}